import {createWebHistory, createRouter} from "vue-router";

import Login from "@/views/pages/Login.vue";
import NotFound from "@/views/pages/NotFound.vue";
import Logout from "@/views/pages/Logout";
import Cart from "@/views/pages/Cart";
import Register from "@/views/pages/Register";
import UserProfile from "@/views/pages/UserProfile";
import ChangePassword from "@/views/pages/ChangePassword";
import OrderOverview from "@/views/pages/OrderOverview";
import store from "./store";
import PublicMenuPlan from "@/views/pages/PublicMenuPlan";
import UserMenuPlan from "@/views/pages/UserMenuPlan";
import ConfirmRegistration from "@/views/pages/ConfirmRegistration";

const routes = [
    {
        path: "/",
        name: "Home",
        component: Login,
        meta: {
            redirectToSpeiseplanIfLoggedIn: true
        }
    },
    {
        path: "/login",
        name: "Login",
        component: Login,
        meta: {
            redirectToSpeiseplanIfLoggedIn: true
        }
    },
    {
        path: "/logout",
        name: "Logout",
        component: Logout,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/speiseplan",
        name: "UserMenuPlan",
        component: UserMenuPlan,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/warenkorb",
        name: "Cart",
        component: Cart,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/registrierung",
        name: "Register",
        component: Register,
        meta: {
            redirectToSpeiseplanIfLoggedIn: true
        },
        props: route => ({ registrationConfigurationId: route.query.configuration }),
    },
    {
        path: "/kundenkonto",
        name: "UserProfile",
        component: UserProfile,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/bestelluebersicht",
        name: "OrderOverview",
        component: OrderOverview,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/passwort-aendern",
        name: "ChangePassword",
        component: ChangePassword,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/speiseplan-oeffentlich",
        name: "PublicMenuPlan",
        component: PublicMenuPlan,
        props: route => ({ clientId: route.query.mandant, menuId: route.query.menu }),
    },
    {
        path: "/:mandantId/confirmRegistration/:confirmToken",
        name: 'ConfirmRegistration',
        component: ConfirmRegistration,
        props: route => ({ mandantId: route.params.mandantId, confirmToken: route.params.confirmToken }),
        meta: {
            showFooter: true
        }
    },
    {
        path: "/:catchAll(.*)",
        name: 'NotFound',
        component: NotFound,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { top: 0 }
    }
});

router.beforeEach((to, from, next) => {
    let isLoggedIn = store.getters.isLoggedIn
    let jwtToken = store.getters.getJwt
    let validJwt = false
    let userPasswordChangeRequired = store.getters.passwordChangeIsRequired

    if (jwtToken !== null) {
        let token = JSON.parse(atob(jwtToken.split('.')[1]))

        if (token.exp*1000 >= Date.now()) {
            validJwt = true
        }
    }

    if((!isLoggedIn || !validJwt) && to.matched.some(record => record.meta.requiresAuth)) {
        next({name: 'Login'})
        return
    }

    // force user to password change page if password change is required
    if (isLoggedIn && validJwt && userPasswordChangeRequired && to.name !== 'ChangePassword' && to.name !== 'Logout') {
        next({name: 'ChangePassword'})
        return
    }

    if(isLoggedIn && validJwt && to.matched.some(record => record.meta.redirectToSpeiseplanIfLoggedIn)) {
        next({name: 'UserMenuPlan'})
        return
    }

    next()
})

export default router;
